import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import jwt_decode from 'jwt-decode';
import { filter } from 'rxjs';

import { Store } from '@ngrx/store';

import { selectChatState } from '../../../store/app.selectors';

import { skipMessagingKey } from '../../../core/services/http.context';
import { MessagingEnvironmentService } from '../../../core/services/messaging-environment.service';
import { IChannel } from '../interfaces/IChannel';
import { AppStateWithChat } from '../store/chat.reducer';

export enum LogModules {
  PROFESSIONALIZESUGGESTED = 'PROFESSIONALIZE-SUGGESTED',
  PROFESSIONALIZEORIGINAL = 'PROFESSIONALIZE-ORIGINAL',
  SMARTREPLIES = 'SMART-REPLIES',
  OPENASSISTANT = 'OPEN-ASSISTANT',
}

export enum LogActions {
  CLICK = 'CLICK',
}

export interface ILog {
  module: LogModules;
  action: LogActions;
  raw?: ILogRaw;
}
export interface ILogRaw {
  conversation_id?: string;
  message_id?: string;
  original?: string;
  suggested?: string;
}

@Injectable()
export class LogsService {
  selectedChannel: IChannel | null = null;
  constructor(
    private httpClient: HttpClient,
    private store: Store<AppStateWithChat>,
    private env: MessagingEnvironmentService
  ) {
    this.setChatSubscriptions();
  }

  setChatSubscriptions(): void {
    this.store
      .select(selectChatState)
      .pipe(filter((data) => data !== undefined))
      .subscribe(({ selectedChannel }) => {
        this.selectedChannel = selectedChannel;
      });
  }
  sendLog(module: LogModules, action: LogActions, data?: unknown) {
    const params: { module: LogModules; action: LogActions; raw?: unknown } = {
      module: module,
      action: action,
    };
    if (data) {
      params.raw = JSON.stringify(data);
    }
    return this.httpClient.post<unknown>(`${this.env.env.logsApi}/register?account-uid=${this.getDealerID()}`, params, {
      context: skipMessagingKey(),
    });
  }

  getDealerID() {
    const token = localStorage.getItem('messaging-token');
    if (!token) {
      return '';
    }
    try {
      const decodedToken: { accountUid: string } = jwt_decode(token);
      return decodedToken?.accountUid ?? '';
    } catch {
      return '';
    }
  }

  sendLogProfessionalizer(log: ILog, message_id: string) {
    const raw: ILogRaw = {
      conversation_id: this.selectedChannel?.uid ?? '',
      message_id: message_id,
    };
    if (log?.raw?.original) {
      raw.original = log.raw.original;
    }
    if (log?.raw?.suggested) {
      raw.suggested = log.raw.suggested;
    }
    this.sendLog(log.module as LogModules, log.action, raw).subscribe();
  }
}
